import { createAction } from 'redux-actions';

export const CONFIRM_DIALOG_OPEN = createAction('CONFIRM_DIALOG_OPEN');
export const CONFIRM_DIALOG_CLOSE = createAction('CONFIRM_DIALOG_CLOSE');

export const showConfirmDialog = (title, message, onOk, noMessage, YesNessage) => {
  return (dispatch, getState) => {    
    dispatch(CONFIRM_DIALOG_OPEN({title, message, onOk, noMessage, YesNessage}));
  };
};

export const closeConfirmDialog = () => {
  return (dispatch, getState) => {        
    dispatch(CONFIRM_DIALOG_CLOSE());
  };
};